import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateCampaign } from '@Modal/hooks/campaigns/useCreateCampaign';

export const CreateCampaignCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelCampaignForm } = useCreateCampaign();

  return (
    <>
      {showCancelCampaignForm && (
        <CancelModal open={showCancelCampaignForm}>
          <ImageCancelDialogLayout
            title="Cancel campaign changes?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in campaign settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
